module.exports = __webpack_public_path__ + "img/diamond.8bff2124.svg";